"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactMentions = require("react-mentions");

var _Avatar = _interopRequireDefault(require("../../ui_elements/avatar/Avatar"));

var _FlexboxGrid = require("../../containers/flexbox_layout/FlexboxGrid");

var _buttons = require("../buttons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Mentions = function Mentions(props) {
  var value = props.value,
      rows = props.rows,
      name = props.name,
      users = props.users,
      style = props.style;
  return /*#__PURE__*/_react.default.createElement(_reactMentions.MentionsInput, _extends({}, props, {
    value: value,
    style: style,
    rows: rows,
    name: name,
    id: name
  }), /*#__PURE__*/_react.default.createElement(_reactMentions.Mention, {
    markup: "**__display__**",
    trigger: "@",
    data: users || [],
    renderSuggestion: function renderSuggestion(highlightedDisplay, focused) {
      return /*#__PURE__*/_react.default.createElement(_FlexboxGrid.FlexRow, {
        className: "user ".concat(focused ? 'focused' : ''),
        style: {
          alignItems: "center"
        }
      }, /*#__PURE__*/_react.default.createElement(_Avatar.default, {
        src: highlightedDisplay.avatar,
        alt: highlightedDisplay.display,
        position: "relative",
        size: "small"
      }), /*#__PURE__*/_react.default.createElement(_buttons.Button, {
        textTransform: "none"
      }, highlightedDisplay.display));
    },
    style: {
      backgroundColor: '#d4eaf4'
    }
  }));
};

var userShape = {
  id: _propTypes.default.number.isRequired,
  display: _propTypes.default.string.isRequired,
  avatar: _propTypes.default.string.isRequired
};
Mentions.propTypes = {
  value: _propTypes.default.string,
  users: _propTypes.default.arrayOf(_propTypes.default.shape(userShape)),
  rows: _propTypes.default.number,
  name: _propTypes.default.string,
  // eslint-disable-next-line
  style: _propTypes.default.object
};
Mentions.defaultProps = {
  value: '',
  rows: 7,
  users: [],
  name: ''
};
var _default = Mentions;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@contently/toolkit/dist/form/inputs/Mentions.js
// module id = 351
// module chunks = 0 15 16 17 18